import { render, staticRenderFns } from "./authorize.vue?vue&type=template&id=6e2851f7&scoped=true&"
import script from "./authorize.vue?vue&type=script&lang=js&"
export * from "./authorize.vue?vue&type=script&lang=js&"
import style0 from "./authorize.vue?vue&type=style&index=0&id=6e2851f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2851f7",
  null
  
)

export default component.exports